import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import GetTimerTimeNodePreview from "../../features/sequence/node_previews/GetTimerTimeNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";

export interface IGetTimerTime extends Interaction {
  storeDataKey: string;
}

export function getGetTimerTimeNodePreview(timer: IGetTimerTime): string {
  const storeKey = timer.storeDataKey || "None";
  return `Get Time -> $${storeKey}`;
}

export const getTimerTimeInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): IGetTimerTime => {
    return {
      id: GetNewGuid(),
      name: "Get Timer Time",
      type: InteractionType.GetTimerTime,
      storeDataKey: "",
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): IGetTimerTime => {
    return interaction as IGetTimerTime;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[]
  ): IGetTimerTime => {
    const casted = interaction as IGetTimerTime;
    return {
      ...casted,
      id: GetNewGuid(),
      name: "Get Timer Time",
      type: InteractionType.GetTimerTime,
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string
  ): string[] => {
    return [];
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[]
  ): string[] => {
    const casted = interaction as IGetTimerTime;
    const errors: string[] = [];

    if (!casted.storeDataKey.trim()) {
      errors.push("Store Data Key is required");
    }

    return errors;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[]
  ): SearchResultData[] => {
    const casted = interaction as IGetTimerTime;
    return getMatchingResults(
      [interaction.name, casted.storeDataKey],
      takeName,
      interaction,
      "Get Timer Time"
    );
  };

  return {
    View: <></>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <GetTimerTimeNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: "Get Timer Time",
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
